import { render } from "./AppointmentDetails.vue?vue&type=template&id=b1124ba4&scoped=true"
import script from "./AppointmentDetails.vue?vue&type=script&lang=js"
export * from "./AppointmentDetails.vue?vue&type=script&lang=js"

import "./AppointmentDetails.vue?vue&type=style&index=0&id=b1124ba4&lang=scss&scoped=true"

import exportComponent from "/var/www/html/vitare-carenew/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1124ba4"]])

export default __exports__